import { getAppVersion } from "~/utils/version";
import { SidebarMenu, SidebarMenuItem } from "~/components/ui/sidebar";

export function AppVersion() {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <div className="flex items-center justify-center px-2 py-1">
          <span className="text-xs text-muted-foreground">
            Version {getAppVersion()}
          </span>
        </div>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
